import styled from 'styled-components';


export const DefaultTitle = styled.span<{ top: number }>`
    font-family: Poppins;
    font-size: 18px;
    font-weight: 600;
    line-height: 27px;
    letter-spacing: 0em;
    text-align: left;
    color: rgba(0, 95, 174, 1);
    padding: ${props => props.top}% 0 16px 24px;
`;
